<!--
 * @Descripttion: 我的审批列表
 * @Author: jschen
 * @Date: 2021-09-05 16:39:41
 * @LastEditors: liaoyijun
 * @LastEditTime: 2022-03-24 15:17:39
-->
<template>
    <div v-show="visible" class="approval-content">
        <el-table v-loading="loading" :height="255" :data="appRecords" style="width: 100%" @row-click="rowAppClick">
            <el-table-column v-if="type === 'PC'" prop="title" label="全部" :show-overflow-tooltip="true">
                <template slot="header" slot-scope="scope">
                    <div v-if="taskGroups.length > 0" class="btn-group">
                        <span
                            v-for="(item, index) in taskGroups"
                            :key="index"
                            :class="{ isactive: item.active }"
                            @click="handleBtnSelect(index, item, scope)"
                            >{{ item.name }}</span
                        >
                    </div>
                    <span v-else>流程标题</span>
                </template>
                <template slot-scope="scope">
                    <span
                        ><span :class="levelStyle(scope.row.alarmLevel)">[{{ levelStatus(scope.row.alarmLevel) }}]</span
                        >{{ scope.row.title }}</span
                    >
                </template>
            </el-table-column>
            <el-table-column v-if="type === 'ipad'" prop="title" label="全部" :show-overflow-tooltip="true">
                <template slot="header" slot-scope="scope">
                    <div class="btn-group">
                        <span
                            v-for="(item, index) in taskGroups"
                            :key="index"
                            :class="{ isactive: item.active }"
                            @click="handleBtnSelect(index, item, scope)"
                            >{{ item.name }}</span
                        >
                    </div>
                </template>
                <template slot-scope="scope">
                    <span
                        ><span :class="levelStyle(scope.row.alarmLevel)">[{{ levelStatus(scope.row.alarmLevel) }}]</span
                        >{{ scope.row.title }}</span
                    >
                </template>
            </el-table-column>
            <el-table-column
                v-if="type === 'PC'"
                key="creatorRealName"
                prop="creatorRealName"
                label="创建人"
                align="center"
                width="100"
            >
            </el-table-column>
            <el-table-column
                v-if="type === 'ipad'"
                prop="processTime"
                :label="[0, 1].includes(searchAppOpt.handleType) ? '停留时间' : '处理用时'"
                width="150"
                :show-overflow-tooltip="true"
                align="center"
            >
                <template slot-scope="scope">
                    <span class="process-color">{{ formatRelayDate(scope.row) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="type === 'PC'"
                prop="processTime"
                :label="[0, 1].includes(searchAppOpt.handleType) ? '停留时间' : '处理用时'"
                :show-overflow-tooltip="true"
                align="center"
                width="150"
            >
                <template slot-scope="scope">
                    <span class="process-color">{{ formatRelayDate(scope.row) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="type === 'PC'"
                prop="createDate"
                sortable
                align="center"
                label="接收时间"
                width="100"
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.createDate | dateFilter }}</span>
                </template>
            </el-table-column>
            <div slot="append" style="width:100%;height:30px;"></div>
            <div slot="empty" class="empty">
                <img src="@/assets/pics/no-empty.png" />
                <span>暂无内容</span>
            </div>
        </el-table>
    </div>
</template>
<script>
import { queryApproval } from "@/api";
import { isMobile, formatProcessTime } from "@/libs/mUtils";
import _ from "lodash";
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            type: "",
            loading: false,
            appRecords: [],
            btnTaskGroups: [
                {
                    name: "全部",
                    key: "ALL",
                    active: true,
                },
                {
                    name: "核心业务",
                    key: "HXYW",
                    active: false,
                },
                {
                    name: "通用业务",
                    key: "TYYW",
                    active: false,
                },
                {
                    name: "人事考勤",
                    key: "RSKQ",
                    active: false,
                },
                {
                    name: "费用报销",
                    key: "FYBX",
                    active: false,
                },
                {
                    name: "工单督办",
                    key: "GDDB",
                    active: false,
                },
            ],
            btnWorkGroups: [
                // {
                //     name: "全部",
                //     key: "ALL",
                //     active: true,
                // },
                // {
                //     name: "工作协同",
                //     key: "GZXT",
                //     active: false,
                // },
                // {
                //     name: "工作通知",
                //     key: "GZTZ",
                //     active: false,
                // },
                // {
                //     name: "活动交流",
                //     key: "RSKQ",
                //     active: false,
                // },
            ],
            searchAppOpt: {
                title: "", // 标题
                taskType: 0, // 0-普通任务；1-工作沟通
                handleType: 0, // 0-待办；1-待阅；2-已办；3-已阅 4-已处理
                handleGroup: "ALL",
                current: 1,
                size: 30,
            },
        };
    },
    computed: {
        taskGroups() {
            if (this.searchAppOpt.taskType === 0) {
                if (this.searchAppOpt.handleGroup === "ALL") {
                    return this.btnTaskGroups.map((item, index) => {
                        return {
                            ...item,
                            active: index === 0,
                        };
                    });
                }
                return this.btnTaskGroups;
            } else {
                if (this.searchAppOpt.handleGroup === "ALL") {
                    return this.btnWorkGroups.map((item, index) => {
                        return {
                            ...item,
                            active: index === 0,
                        };
                    });
                }
                return this.btnWorkGroups;
            }
        },
        levelStatus() {
            return function(status) {
                let level = parseInt(status);
                let levelName = "一般";
                switch (level) {
                    case 1:
                        levelName = "紧急";
                        break;
                    case 2:
                        levelName = "重要";
                        break;
                    default:
                        levelName = "一般";
                        break;
                }
                return levelName;
            };
        },
        levelStyle() {
            return function(level) {
                return `level${level}`;
            };
        },
    },
    mounted() {
        this.type = document.body.clientWidth > 1220 ? "PC" : "ipad";
    },
    methods: {
        loadData() {
            this.queryAppList();
        },
        refresh() {
            const { taskType, handleGroup, handleType, title } = _.cloneDeep(this.searchAppOpt);
            this.searchAppOpt = {
                title: title, // 标题
                taskType, // 0-普通任务；1-工作沟通
                handleType, // 0-待办；1-待阅；2-已办；3-已阅 4-已处理
                handleGroup,
                current: 1,
                size: 30,
            };
            this.loadData();
        },
        changeSearchOps(item) {
            this.searchAppOpt = {
                ...this.searchAppOpt,
                ...item,
            };
        },
        formatRelayDate(date) {
            // 0-待办；1-待阅；2-已办；3-已阅 4-已处理
            const { createDate, finishTime = "" } = date;
            // if (this.searchAppOpt.taskType === 1) {
            //     return formatProcessTime(createDate, "耗时", finishTime);
            // } else {
            //     if ([0, 1].includes(this.searchAppOpt.handleType)) {
            //         return formatProcessTime(createDate);
            //     } else {
            //         return formatProcessTime(createDate, "耗时", finishTime);
            //     }
            // }
            if ([0, 1].includes(this.searchAppOpt.handleType)) {
                return formatProcessTime(createDate);
            } else {
                return formatProcessTime(createDate, "耗时", finishTime);
            }
        },
        // rowAppClick({ mobileLink, link }) {
        //     if (isMobile()) {
        //         this.handleRouterJump(1, mobileLink, "", true);
        //         return;
        //     }
        //     this.handleRouterJump(1, link, "", true);
        //     // window.open(link);
        // },
        rowAppClick({ mobileLink, link }) {
            if (isMobile()) {
                window.open(mobileLink);
                return;
            }
            window.open(link);
        },
        // 查询审批列表
        async queryAppList() {
            this.loading = true;
            try {
                const { body, code, message } = await queryApproval({
                    ...this.searchAppOpt,
                });
                if (code === "0000") {
                    this.appRecords = body.records;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
        handleBtnSelect(index, item) {
            const newBtnGroups = _.cloneDeep(this.taskGroups).map((item, idx) => {
                return {
                    ...item,
                    active: idx === index,
                };
            });
            this.searchAppOpt.handleGroup = item.key;
            if (this.searchAppOpt.taskType === 0) {
                this.btnTaskGroups = newBtnGroups;
            } else {
                this.btnWorkGroups = newBtnGroups;
            }
            this.queryAppList();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
